export { default } from '@triptyk/ember-select/modifiers/focus-trap';
